import * as GeneralRepository from "./general-repository";
import * as CuestionarioProvider from "../providers/cuestionario-provider";
import * as CuestionarioMapper from "../mappers/cuestionario-mapper";

export const iniciarCuestionario = async (asegurado, productos, esAPFamiliar, conyuge, hijos, fumador) => {
    const request = CuestionarioMapper.mapDataToCuestionario(asegurado, productos, esAPFamiliar, conyuge, hijos, fumador)
    const response = await CuestionarioProvider.iniciarCuestionario(request)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            cuestionario: response.entity
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await iniciarCuestionario(asegurado, productos, esAPFamiliar, conyuge, hijos, fumador)
            } else {
                return {
                    error: response.auditResponse,
                    cuestionario: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                cuestionario: null
            }
        }
    }
}

export const obtenerResultadoCuestionario = async (assessmentId, productos) => {
    const response = await CuestionarioProvider.obtenerResultadoCuestionario({
        assessmentId: assessmentId,
        producto: productos
    })
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            resultado: response.entity
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerResultadoCuestionario(assessmentId, productos)
            } else {
                return {
                    error: response.auditResponse,
                    resultado: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                resultado: null
            }
        }
    }
}

export const guardarCuestionario = async (idSolicitudMultiple, cuestionario) => {
    const response = await CuestionarioProvider.guardarCuestionario(idSolicitudMultiple, cuestionario)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            resultado: response.entity
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarCuestionario(cuestionario)
            } else {
                return {
                    error: response.auditResponse,
                    resultado: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                resultado: null
            }
        }
    }
}